import { PageRendererArgs, PageRendererFeatureFlags } from "@softr-io/blocks-sdk";
import { createContext, useContext } from "react";
import { Lifecycle } from "./Lifecycle";

export interface AppConstants {
    appId: string;
    baseUrl: string;
    blockIdAttributeName: PageRendererArgs["blockIdAttributeName"];
    slotBlockIdAttributeName: PageRendererArgs["slotBlockIdAttributeName"];
    slotIdAttributeName: PageRendererArgs["slotIdAttributeName"];
    mode: PageRendererArgs["mode"];
    spaMode: boolean;
    lifecycle: Lifecycle;
    studioEventEmitter: PageRendererArgs["studioEventEmitter"];
    featureFlags: PageRendererFeatureFlags;
    aiApp: PageRendererArgs["aiApp"];
    showMadeWithBadge: PageRendererArgs["showMadeWithBadge"];
    badgeType: PageRendererArgs["badgeType"];
}

export const AppConstantsContext = createContext<AppConstants | null>(null);

export function useAppConstants(): AppConstants {
    const context = useContext(AppConstantsContext);
    if (!context) {
        throw new Error("useAppConstants must be used within an AppConstantsProvider");
    }
    return context;
}
